import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useFloating, offset, flip, arrow, useHover, useFocus, useRole, useInteractions, FloatingPortal, FloatingArrow, useTransitionStyles } from '@floating-ui/react';
import { useState } from 'react';
import { Text } from '../Text/Text.js';
import styles from './Tooltip.module.css.js';

function Tooltip({ text, disabled = false, children, }) {
    const arrowWidth = 14;
    const arrowHeight = 8;
    const lines = Array.isArray(text) ? text : [text];
    const [isOpen, setIsOpen] = useState(false);
    const [arrowEl, setArrowEl] = useState(null);
    const { refs, context, floatingStyles, middlewareData } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: "top",
        middleware: [
            offset(arrowHeight),
            flip(),
            arrow({
                element: arrowEl,
            }),
        ],
    });
    const hover = useHover(context, {
        move: false,
        delay: { open: 200, close: 50 },
    });
    const focus = useFocus(context);
    const role = useRole(context, { role: "tooltip" });
    const { getReferenceProps, getFloatingProps } = useInteractions([
        hover,
        focus,
        role,
    ]);
    const { isMounted, styles: transitionStyles } = useFloatingUITransitionStyles(context, middlewareData, arrowWidth, arrowHeight);
    return (jsxs(Fragment, { children: [jsx("span", Object.assign({ className: styles.Anchor, ref: refs.setReference }, getReferenceProps(), { children: children })), !disabled && isMounted ?
                jsx(FloatingPortal, { children: jsx("div", Object.assign({ ref: refs.setFloating, style: floatingStyles, className: styles.Container }, getFloatingProps(), { children: jsx("div", { style: transitionStyles, children: jsxs("div", { className: styles.Tooltip, children: [jsx(FloatingArrow, { ref: setArrowEl, context: context, width: arrowWidth, height: arrowHeight }), lines.map((line) => (jsx(Text, { align: "start", children: line }, line)))] }) }) })) })
                : null] }));
}
function useFloatingUITransitionStyles(context, middlewareData, arrowWidth, arrowHeight) {
    var _a, _b, _c, _d;
    const arrowX = (_b = (_a = middlewareData.arrow) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : 0;
    const arrowY = (_d = (_c = middlewareData.arrow) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : 0;
    const transformX = arrowX + arrowWidth / 2;
    const transformY = arrowY + arrowHeight;
    return useTransitionStyles(context, {
        duration: { open: 200, close: 50 },
        initial: {
            opacity: 0,
            transform: "scale(0.9)",
        },
        close: {
            opacity: 0,
            transform: "scale(0.8)",
        },
        common: ({ side }) => ({
            transformOrigin: {
                top: `${transformX.toString()}px calc(100% + ${arrowHeight.toString()}px)`,
                bottom: `${transformX.toString()}px ${(-arrowHeight).toString()}px`,
                left: `calc(100% + ${arrowHeight.toString()}px) ${transformY.toString()}px`,
                right: `${(-arrowHeight).toString()}px ${transformY.toString()}px`,
            }[side],
        }),
    });
}

export { Tooltip };
//# sourceMappingURL=Tooltip.js.map
